import React from 'react'
import { Heading, Text, Button } from '@primer/react-brand'

import CenteredAuthLayout from '../components/CenteredAuthLayout'

// Lightweight landing the org-email confirmation link redirects to
// (OrganizationsController#confirm_email → MainController#email_confirmed).
// No design exists for this page — it reuses the standard centered auth shell
// and keeps to the established Heading/Text/Button pieces.
//
// Props: { membershipPath, signInPath, currentUser }
const EmailConfirmedPage = ({ membershipPath, signInPath, currentUser }) => {
  return (
    <CenteredAuthLayout
      maxWidth={480}
      membershipPath={membershipPath}
      signInPath={signInPath}
      currentUser={currentUser}
    >
      <Heading as="h1" size="5">Your organization&rsquo;s email is confirmed</Heading>
      <Text as="p" variant="muted" style={{ marginTop: 14 }}>
        You can now subscribe.
      </Text>
      <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginTop: 24 }}>
        <Button
          as="a"
          href="/membership"
          variant="primary"
          style={{
            backgroundColor: 'var(--base-color-scale-blue-5)',
            borderColor: 'var(--base-color-scale-blue-5)',
            borderRadius: '6px',
          }}
        >
          Choose a plan
        </Button>
        <Button as="a" href="/monitoring" variant="subtle">
          Go to dashboard
        </Button>
      </div>
    </CenteredAuthLayout>
  )
}

export default EmailConfirmedPage
